import Vue from "vue";
import Vuex from "vuex";
import VuePursue from "vue-pursue";

import app from "@/store/app";
import user from "@/store/user";
import trello from "@/store/trello";
// import goal from "@/store/goal";
// import timekeeper from "@/store/timekeeper";
import calendar from "@/store/calendar";
import session from "@/store/session";
// import contact from "@/store/contact";
import optimizer from "@/store/optimizer";
import dayplanner from "@/store/dayplanner";
import timeslots from "@/store/timeslots"; // merge with optimizer?
// import updateVuexOnFirestoreUpdatePlugin from "@/store/plugin";
import createStoreLogger, { loggerMutations } from "@/store/logger";
// import { firebaseMutations } from "vuexfire";
import { genericStoreMutations } from '@/generic_api/lib/generic_store/vuefire'

// See: https://github.com/posva/vuexfire/tree/firestore

/*
TODO UNDO/REDO:
- Define actions and mutations
- Don't edit state directly
- For each action define an inverse action:
  UPDATE, INV_UPDATE that reverses the action at firestore
- keep track of all inverse actions too
See article: https://dzone.com/articles/create-a-vuex-undoredo-plugin-for-vuejs
*/

/* Enable logger for these modules */
const vuexLoggerPlugin = createStoreLogger([
  'app',
  'user',
  'trello',
  // 'goal',
  'calendar',
  'session',
  // 'contact',
  'optimizer',
  'timeslots',
  'dayplanner'
]);

Vue.use(Vuex);
Vue.use(VuePursue);

const store = new Vuex.Store({
  strict: true,

  plugins: [
    // updateVuexOnFirestoreUpdatePlugin,
    /* Disable logger in production */
    process.env.NODE_ENV !== 'production'
      ? vuexLoggerPlugin
      : () => {},
    process.env.NODE_ENV !== 'production'
      ? VuePursue
      : () => {}
  ],

  state: {
    // res: {}, // NOT USED
    // index: {}, // NOT USED
    // sync: {} // NOT USED
  },

  mutations: {
    // ...firebaseMutations,
    ...genericStoreMutations,
    ...loggerMutations
  },

  actions: {
    clearAll({ commit }) {
      commit("app/RESET")
      commit("user/LOGOUT")
      // commit("trello/RESET")
      commit("calendar/RESET")
      commit("session/RESET")
      commit("optimizer/RESET")
      commit("timeslots/RESET")
    }
  },

  modules: {
    app,
    user,
    trello,
    // goal,
    // timekeeper,
    calendar,
    session,
    // contact,
    optimizer,
    timeslots,
    dayplanner
  }
});

if (module.hot) {
  // accept actions and mutations as hot modules
  module.hot.accept([
    './app',
    './user',
    './trello',
    // './goal',
    './calendar',
    './session',
    // './contact',
    './optimizer',
    './timeslots',
    './dayplanner'
  ], (filename) => {

    /* Parse "./src/store/<moduleName>/index.js" */
    let moduleName = filename[0].split('/').reverse()[1];

    console.log("[HMR*] update store module %c<" + moduleName + ">", 'color: #42b983');

    /* Path must be hardcoded! */
    let updatedModule;
    switch (moduleName) {
      case 'app':       updatedModule = require('./app'); break;
      case 'user':      updatedModule = require('./user'); break;
      case 'trello':    updatedModule = require('./trello'); break;
      // case 'goal':      updatedModule = require('./goal'); break;
      case 'calendar':  updatedModule = require('./calendar'); break;
      case 'session':   updatedModule = require('./session'); break;
      // case 'contact':   updatedModule = require('./contact'); break;
      case 'optimizer': updatedModule = require('./optimizer'); break;
      case 'timeslots': updatedModule = require('./timeslots'); break;
      case 'dayplanner':updatedModule = require('./dayplanner'); break;
    }
    // console.log("updatedModule", updatedModule);

    store.hotUpdate({
      modules: {
        [moduleName]: {
          namespaced: true,
          mutations:  updatedModule.default.mutations,
          actions:    updatedModule.default.actions,
          getters:    updatedModule.default.getters
        }
      }
    })
  })
}

window.VuexStore = store;
export default store;
